// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-m_ht","advertDetailServiceList__header":"c-m_hu","advertDetailServiceList__list":"c-m_hv"};